/**
 * Map stay booking API payload to BookingConfirmation UI shape.
 */
export function transformStayBookingForConfirmation(apiBooking, userFallback = null) {
  if (!apiBooking) return null;

  const checkInDate = new Date(apiBooking.checkIn);
  const checkOutDate = new Date(apiBooking.checkOut);
  const nights = Math.ceil((checkOutDate - checkInDate) / (1000 * 60 * 60 * 24));

  const formatDateString = (date) =>
    date.toLocaleDateString('en-US', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });

  const stayListingImage = apiBooking.stay?.images?.[0] || null;
  const selectedRooms = (apiBooking.lineItems || []).map((lineItem, index) => ({
    id: lineItem.roomId || `room_${index}`,
    name: lineItem.title || 'Room',
    quantity: lineItem.quantity || 1,
    price: lineItem.unitPrice?.discountedPrice || lineItem.lineTotals?.subTotal || 0,
    taxes: lineItem.unitPrice?.taxes || lineItem.lineTotals?.taxes || 0,
    bedType: lineItem.bedType || 'Standard',
    sleeps: lineItem.sleeps || 2,
    image: lineItem.image || stayListingImage || null
  }));

  const guestName = apiBooking.guestInfo?.name || userFallback?.name || 'Guest';

  return {
    bookingId: apiBooking.bookingId,
    property: apiBooking.stay
      ? {
          id: apiBooking.stay.stayId || apiBooking.stayId,
          name: apiBooking.stay.title || 'Property',
          location:
            apiBooking.stay.address ||
            `${apiBooking.stay.city || ''} ${apiBooking.stay.state || ''}`.trim(),
          image: apiBooking.stay.images?.[0] || null,
          images: apiBooking.stay.images || [],
          latitude: apiBooking.stay.latitude || null,
          longitude: apiBooking.stay.longitude || null
        }
      : {
          id: apiBooking.stayId,
          name: 'Property',
          location: 'Location not specified'
        },
    dates: {
      checkIn: formatDateString(checkInDate),
      checkOut: formatDateString(checkOutDate),
      checkInDate: apiBooking.checkIn,
      checkOutDate: apiBooking.checkOut,
      checkInTime: '2:00 PM',
      checkOutTime: '11:00 AM',
      duration: `${nights} Night${nights !== 1 ? 's' : ''}`
    },
    selectedRooms:
      selectedRooms.length > 0
        ? selectedRooms
        : [
            {
              id: 'room_1',
              name: 'Room',
              quantity: 1,
              price: apiBooking.pricingSummary?.subTotal || 0,
              taxes: apiBooking.pricingSummary?.taxes || 0
            }
          ],
    pricing: {
      roomPrice: apiBooking.pricingSummary?.subTotal || 0,
      taxes: apiBooking.pricingSummary?.taxes || 0,
      discount: 0,
      total: apiBooking.pricingSummary?.grandTotal || 0
    },
    user: {
      name: guestName,
      firstName: guestName.split(' ')[0],
      lastName: guestName.split(' ').slice(1).join(' '),
      email: apiBooking.guestInfo?.email || userFallback?.email || '',
      mobile: apiBooking.guestInfo?.mobile || userFallback?.mobile || ''
    },
    guestData: {
      adults: 2,
      children: 0,
      pets: 0
    }
  };
}
